var React = require('react');

function Clt (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 26H25V2H3V26ZM11.3793 23.0986H9.98519V17.0414C9.98519 17.0414 11.3793 17.1883 11.3793 18.1444V23.0986ZM14.8651 23.0986H13.4707V17.0414C13.4707 17.0414 14.8651 17.1883 14.8651 18.1444V23.0986ZM18.1952 23.0986H16.8007V17.0414C16.8007 17.0414 18.1952 17.1883 18.1952 18.1444V23.0986ZM20.4201 15.9401L7.76024 15.9399V14.61H20.4201V15.9401ZM22.7036 13.3033H5.29612V11.9733H11.0573C12.0021 11.9733 13.1712 12.7881 13.1712 12.7881L7.44386 7.3252L8.42965 6.38479L13.3029 11.033V4.33615H14.6972V11.033L19.5695 6.38535L20.5553 7.32564L14.8288 12.7881C14.8288 12.7881 15.9979 11.9733 16.9425 11.9733H22.7036V13.3033Z","fill":"#39BAD0"}));
}

Clt.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Clt;

Clt.default = Clt;
